/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementPolicyMapping extends models.JiraServiceManagementMappingBase {
    getFixupPrototypeFunction() { return JiraServiceManagementPolicyMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementPolicyMapping>): JiraServiceManagementPolicyMapping {
        let obj = Object.assign(new JiraServiceManagementPolicyMapping(), model);
        JiraServiceManagementPolicyMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementPolicyMapping>): JiraServiceManagementPolicyMapping {
        if (!model) return null;
        return JiraServiceManagementPolicyMapping.newInstance(<JiraServiceManagementPolicyMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementPolicyMapping) {
        if (!obj) return;

        models.JiraServiceManagementPolicyMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementPolicyMapping): boolean {
        if (models.JiraServiceManagementMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementPolicyMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Policy attribute enums.
     */
    description_attributes: Array<models.DescriptionAttributeForItsmPolicy>;

    /**
     * List of Policy attribute mappings.
     */
    attribute_mappings: Array<models.JiraServiceManagementIncidentManagementConfigurationMappingForPolicyViolation>;

}
